import script from "./RegisterV2.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterV2.vue?vue&type=script&setup=true&lang=js"

import "./RegisterV2.vue?vue&type=style&index=0&id=10796b6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10796b6a"]])

export default __exports__